import React from 'react';
import { CONFIG } from '../constants';

const PaymentModal = ({ 
  selectedBill, 
  onClose, 
  onSwishPayment, 
  onMarkAsPaid 
}) => {
  if (!selectedBill) return null;

  return (
    <div className="billing-modal" onClick={onClose}>
      <div className="billing-modal-content" onClick={e => e.stopPropagation()}>
        <h3>Bekräfta betalning</h3>
        <div className="payment-confirmation">
          <p><strong>Familj:</strong> {selectedBill.family}</p>
          <p><strong>Nätter:</strong> {selectedBill.nights}</p>
          <p><strong>Kostnad nätter:</strong> {selectedBill.nightsCost} kr</p>
          {selectedBill.electricityCost > 0 && (
            <p><strong>Elkostnad:</strong> {selectedBill.electricityCost.toFixed(1)} kr</p>
          )}
          <p><strong>Total kostnad:</strong> {selectedBill.totalCost} kr</p>
          <p><strong>Redan betalt:</strong> {selectedBill.paidAmount} kr</p>
          <p className="payment-total"><strong>Att betala:</strong> {selectedBill.remainingCost} kr</p>
        </div>
        <div className="modal-buttons">
          <button 
            className="swish-button"
            onClick={onSwishPayment}
          >
            Betala med Swish
          </button>
          <button 
            className="save-button"
            onClick={onMarkAsPaid}
          >
            Jag har swishat/betalat
          </button>
          <button 
            className="close-button" 
            onClick={onClose}
          >
            Avbryt
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentModal;
